import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { StyledYear, StyledMonth } from './style';

const Day = ({ date, className }) => (
  <time className={className} dateTime={format(date, 'YYYY-MM-DD hh:mm')}>
    <StyledYear format="YYYY" element="span">
      {date}
    </StyledYear>
    <StyledMonth format="MMMM" element="span">
      {date}
    </StyledMonth>
  </time>
);

Day.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string
};

export default Day;
